import type { BooleanFlag } from './baseTypes';

export interface TourAlbumResp {
  id: number;
  name: string;
  parentId: number;
  createDate: number;
  updateDate: number;
  children: TourAlbumItem[];
}

export enum TourItemStatus {
  waiting = 0,
  success = 1,
  failed = 2,
}

export interface TourItem {
  id: number;
  tid: string;
  name: string;
  remark: string;
  thumbUrl: string;
  selected: number;
  keywords: string;
  channelId?: number;
  subChannel?: string;
  createDate: number;
  updateDate: number;
  pvCount: number;
  likeCount: number;
  status: TourItemStatus; // # 0:待审核 1:审核成功 2:审核失败
  privilege: 0 | 1 | 2; // 0:不开放 1:开放 2:密码
  password: string;
  expired: BooleanFlag;
  expireDate: number;
  locked: BooleanFlag; // 是否锁住
  shareConfig: TourItemShareConfig;
  sceneCount: number;
  album?: {
    id: number;
    name: string;
  };
  operatorId?: number;
  operatorName?: string;
}
export interface TourItemShareConfig {
  title: string;
  remark: string;
  thumb: string;
  qrMediaId: number; // 二维码的媒体数据ID
  qrMediaUrl: string; // 二维码的媒体数据
}

export interface TourAlbumItem {
  id: number;
  name: string;
  createDate: number;
  updateDate: number;
  parentId?: number;
  parent?: {
    id: number;
    name: string;
  };
  operatorId?: number;
  operatorName?: string;
}
